import {
    PIPELINE_EVENTS_CHANGED,
    UNSEEN_PIPELINE_EVENTS_CHANGED,
    PIPELINE_EVENTS_LOADING_CHANGED
  } from '../constants';
import { toast } from 'react-toastify';

const axios = require('axios').default;

export const fetchPipelineEventsForArtist = (dispatch, team, artist) => {
    return dispatch => {
      dispatch(pipelineEventsLoadingChanged(true));
      return axios.get("/teams/" + team.id + "/pipeline_events", {
          params: {
            artist_id: artist.permalink
          }
        })
        .then(({ data }) => {
          dispatch(pipelineEventsChanged(data));
          dispatch(unseenPipelineEventsChanged([]));
          dispatch(pipelineEventsLoadingChanged(false));
          
          if (data.length === 0) {
            toast.error("No activity data available for this artist.");
          }
        })
        .catch((error) => {
          dispatch(pipelineEventsLoadingChanged(false));
          toast.error("Failed to load activity data. Please try again.");
        })
    };
  };

export const pipelineEventsChanged = (pipelineEvents) => ({
    type: PIPELINE_EVENTS_CHANGED,
    pipelineEvents
});

export const unseenPipelineEventsChanged = (pipelineEvents) => ({
    type: UNSEEN_PIPELINE_EVENTS_CHANGED,
    pipelineEvents
});

export const pipelineEventsLoadingChanged = (isLoading) => ({
    type: PIPELINE_EVENTS_LOADING_CHANGED,
    isLoading
});